import { render, staticRenderFns } from "./OtherFormFilingLocation.vue?vue&type=template&id=0b8743c9"
import script from "./OtherFormFilingLocation.vue?vue&type=script&lang=ts"
export * from "./OtherFormFilingLocation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports